import * as React from "react";
const RightPage = (props) => (
  <svg
    width={12}
    height={21}
    viewBox="0 0 12 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4201 10.7988L2.87406 19.6895C2.4619 20.1183 1.79367 20.1183 1.38155 19.6895L0.384798 18.6526C-0.0266646 18.2245 -0.027456 17.5307 0.383039 17.1017L7.15592 10.0224L0.383039 2.94315C-0.027456 2.51408 -0.0266646 1.82031 0.384798 1.39225L1.38155 0.355287C1.79372 -0.073507 2.46194 -0.073507 2.87406 0.355287L11.42 9.24604C11.8322 9.67479 11.8322 10.37 11.4201 10.7988Z"
      fill="#BD9F3F"
    />
  </svg>
);
export default RightPage;
